import { render } from "./DeepPeformanceNewOverview.vue?vue&type=template&id=250c65ac&scoped=true&ts=true"
import script from "./DeepPeformanceNewOverview.vue?vue&type=script&lang=ts"
export * from "./DeepPeformanceNewOverview.vue?vue&type=script&lang=ts"

import "./DeepPeformanceNewOverview.vue?vue&type=style&index=0&id=250c65ac&scoped=true&lang=css"
import "./DeepPeformanceNewOverview.vue?vue&type=style&index=1&id=250c65ac&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250c65ac"]])

export default __exports__